import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { MarinaOrder, OrderItem, Product, SlingConfig } from 'src/app/models';
import { MarinaOrderDetachedInput } from 'src/app/models/dtos/negotiatedebit/MarinaOrderDetachedInput';
import { PrincingType, ProductType } from 'src/app/models/enums';
import { FinancesService } from 'src/app/services/finances.service';
import { NegotiatedebitService } from 'src/app/services/negotiatedebit/negotiatedebit.service';
import { ProductService } from 'src/app/services/product.service';
import { SlingConfigService } from 'src/app/services/sling-config.service';
import { buildYearOptions } from 'src/app/utils/year-options.util';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-negotiate-create',
  templateUrl: './negotiate-create.component.html',
  styleUrls: ['./negotiate-create.component.scss'],
})
export class NegotiateCreateComponent implements OnInit {
  selectedOrders: any[] = [];
  taxes: Product[] = [];
  selectedTax: Product | null = null;
  discountValue: number = 0;
  taxesValue: number = 0;
  optionsProduct: SelectItem[] = [];
  negotiateOrder: MarinaOrder = new MarinaOrder();
  selectedCustomer: any = null;
  editValue: boolean = false;
  products: Product[] = [];
  slingConfig: SlingConfig | null = null;
  duedate: Date = new Date();
  parcels: number = 1;
  personalDate: boolean = false;
  billingPortifolioList: SelectItem[] = [];
  monthsReference: any[] = [
    { label: 'Janeiro', value: 0 },
    { label: 'Fevereiro', value: 1 },
    { label: 'Março', value: 2 },
    { label: 'Abril', value: 3 },
    { label: 'Maio', value: 4 },
    { label: 'Junho', value: 5 },
    { label: 'Julho', value: 6 },
    { label: 'Agosto', value: 7 },
    { label: 'Setembro', value: 8 },
    { label: 'Outubro', value: 9 },
    { label: 'Novembro', value: 10 },
    { label: 'Dezembro', value: 11 },
  ];
  years: SelectItem[] = buildYearOptions();
  yearSelected: any = null;
  monthReferenceSelected: any = null;
  totalNegotiate: number = 0;
  carteiraSelect: any = null;
  constructor(
    public dialog: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private productService: ProductService,
    private slingConfigService: SlingConfigService,
    private negotiatedebitService: NegotiatedebitService,
    private financesService: FinancesService,
    private spinner: NgxSpinnerService
  ) {}

  async ngOnInit() {
    this.selectedOrders = this.config.data.table || [];
    this.selectedCustomer = this.config.data.customer || null;
    await this.loadProduct();
    this.slingConfig = await this.findSlingConfig();
    this.addMainValue();
    this.getBilingPortifolioList();
  }

  getBilingPortifolioList(): void {
    this.financesService.getAllBilingPortifolio().subscribe(
      (data) => {
        this.billingPortifolioList = data.map((item) => ({
          label: item.nome,
          value: item.idCarteiraCobranca,
        }));
      },
      (error) => {
        console.log(error);
      }
    );
  }
  async findSlingConfig(): Promise<SlingConfig> {
    return new Promise<SlingConfig>(async (resolve) => {
      this.slingConfigService.getSlingConfig().subscribe(
        async (slingConfig: SlingConfig[]) => {
          resolve(slingConfig[0]);
        },
        async () => {
          resolve(null);
        }
      );
    });
  }

  getTotalPending(): number {
    return this.selectedOrders.reduce((total, order) => {
      return total + (order.value || 0);
    }, 0);
  }

  getTotalPendingMoraAndMulta(): number {
    return this.selectedOrders.reduce((total, order) => {
      return total + (order.mora + order.multa || 0);
    }, 0);
  }

  getTotalNegotiate(): number {
    return this.selectedOrders.reduce((total, order) => {
      return total + (order.value + order.mora + order.multa || 0);
    }, 0);
  }

  addMainValue() {
    let orderItem: OrderItem = new OrderItem();
    orderItem.product = this.products.find(
      (p) => p.id === this.slingConfig?.negotiateProductId
    );
    orderItem.qtyRequested = 1;
    orderItem.qtySupplied = 1;
    orderItem.itemValue = this.getTotalNegotiate();
    orderItem.totalValue = this.getTotalNegotiate();

    this.negotiateOrder.orderItems.push(orderItem);
    this.calcTotalToPayFinal();
  }

  addTaxes() {
    if (!this.selectedTax) {
      Swal.fire({
        title: 'Erro',
        text: 'Selecione um serviço para adicionar.',
        icon: 'error',
      });
      return;
    }
    let orderItem: OrderItem = new OrderItem();

    orderItem.product = this.selectedTax;
    orderItem.qtyRequested = 1;
    orderItem.qtySupplied = 1;
    orderItem.itemValue = this.taxesValue;
    orderItem.totalValue = this.taxesValue;

    this.negotiateOrder.orderItems.push(orderItem);

    this.calcTotalToPayFinal();
  }

  calcTotalToPayFinal(): void {
    this.totalNegotiate = this.negotiateOrder.orderItems.reduce(
      (total, order) => {
        return total + (order.totalValue || 0);
      },
      0
    );
    this.totalNegotiate = this.totalNegotiate - this.discountValue;
  }

  async loadProduct(): Promise<void> {
    const data = await firstValueFrom(
      this.productService.getByProductType(ProductType.Service)
    );
    this.products = data;

    const resultToCredit = data.filter(
      (product) =>
        product.active && product.pricingType === PrincingType.SimplePrice
    );

    this.optionsProduct = resultToCredit.map((result) => ({
      label: result.name,
      value: result,
    }));
  }

  changeProduct(event) {
    if (event.value.price.priceFree) {
      this.taxesValue = 0;
      this.editValue = false;
    } else {
      this.taxesValue = event.value.price.value;
      this.editValue = true;
    }
  }

  removeOrderItem(index: number): void {
    if (index > 0) {
      this.negotiateOrder.orderItems.splice(index, 1);
    }
    this.calcTotalToPayFinal();
  }

  getTotalOtherServices(): number {
    let total = 0;
    let i: number = 0;
    this.negotiateOrder.orderItems.forEach((item) => {
      if (i > 0) {
        total += item.totalValue;
      }
      i++;
    });
    return total;
  }

  async negotiate() {
    if (this.discountValue > this.negotiateOrder.orderItems[0].totalValue) {
      Swal.fire({
        title: 'Erro',
        text: 'O desconto não pode ser maior que o valor original da negociação.',
        icon: 'error',
      });
      return;
    }

    //para forcar o authenticate code depois trocar por um mais leve
    this.slingConfig = await this.findSlingConfig();
    this.negotiateOrder.customer = this.selectedCustomer;
    this.negotiateOrder.orderItems[0].discount = this.discountValue;
    this.negotiateOrder.orderObs =
      'Negociação de Dívida - Faturas originais: ' +
      this.selectedOrders
        .map((order) => {
          const comp = order.competenceDate
            ? moment(order.competenceDate).format('MM/YYYY')
            : '-';
          const venc = order.dueDate
            ? moment(order.dueDate).format('DD/MM/YYYY')
            : '-';
          return `${order.invoiceNumber} (Comp. ${comp}, Venc. ${venc})`;
        })
        .join('; ');
    this.negotiateOrder.origin = 'NEGOTIATION';
    let negotiateSent: MarinaOrderDetachedInput = new MarinaOrderDetachedInput(
      this.negotiateOrder
    );

    if (this.carteiraSelect == null || this.carteiraSelect == undefined) {
      Swal.fire({
        title: 'Erro',
        text: 'Selecione uma carteira para a negociação.',
        icon: 'error',
      });
      return;
    }

    if (this.parcels < 1) {
      Swal.fire({
        title: 'Erro',
        text: 'O número de parcelas deve ser pelo menos 1.',
        icon: 'error',
      });
      return;
    }

    if (
      this.personalDate &&
      (this.monthReferenceSelected == null || this.yearSelected == null)
    ) {
      Swal.fire({
        title: 'Erro',
        text: 'A data de vencimento deve ser preenchida.',
        icon: 'error',
      });
      return;
    }

    Swal.fire({
      title: 'Confirmação',
      text: 'Deseja realmente criar a negociação?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      reverseButtons: true,
    })
      .then((result) => {
        if (result.isConfirmed) {
          this.spinner.show();
          const negotiateDto = {
            order: negotiateSent,
            parcels: this.parcels,
            dueDate: this.duedate,
            personaldate: this.personalDate,
            monthReference: this.monthReferenceSelected,
            carterira: this.carteiraSelect,
            invoiceIds: this.selectedOrders.map((order) => order.id),
            referenceYear: this.yearSelected,
          };

          this.negotiatedebitService
            .createNegotiateOrder(negotiateDto)
            .subscribe({
              next: (response) => {
                console.log(response);
                if (response === '') {
                  Swal.fire({
                    title: 'Sucesso',
                    text: 'Negociação criada com sucesso!',
                    icon: 'success',
                    confirmButtonText: 'OK',
                  }).then(() => {
                    this.spinner.hide();
                    this.dialog.close();
                  });
                } else {
                  this.spinner.hide();
                  Swal.fire({
                    title: 'Atenção',
                    html: response,
                    icon: 'warning',
                  });
                }
              },
              error: (error) => {
                this.spinner.hide();
                console.error('Error negotiating:', error);
                Swal.fire({
                  title: 'Erro',
                  text:
                    error.error?.message ||
                    'Ocorreu um erro ao criar a negociação. Por favor, tente novamente.',
                  icon: 'error',
                });
              },
            });
        }
      })
      .catch((error) => {
        this.spinner.hide();
        console.error('Error negotiating:', error);
        Swal.fire({
          title: 'Erro',
          text: 'Ocorreu um erro ao criar a negociação. Por favor, tente novamente.',
          icon: 'error',
        });
      });
  }
}
